import React, { useEffect, useState } from 'react';
import { useAddCalendarMeetingContextMutation } from '../../api/calendar.js';
import BaseOverlay from '../../components/layout/BaseOverlay.jsx';
import BaseButton from '../form/BaseButton.jsx';
import { useErrorToast } from '../../hooks/useToast.jsx';

const MeetingContextEdit = ({ calendarMeetingId, context }) => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [contextState, setContextState] = useState('');

    const [addCalendarMeetingContext, { isLoading, error }] = useAddCalendarMeetingContextMutation();

    const editContext = () => {
        setShowOverlay(true);
        setContextState(context);
    };

    const closeOverlay = () => {
        setShowOverlay(false);
    };

    const handleContextChange = (e) => {
        setContextState(e.target.value);
    };

    useEffect(() => {
        if (error) {
            useErrorToast(error?.data?.message || 'An error occurred while saving the context.');
        }
    }, [error]);

    const saveContext = async () => {
        const requestData = { context: contextState };
        await addCalendarMeetingContext({ id: calendarMeetingId, data: requestData });
        closeOverlay();
    };

    return (
        <>
            <BaseButton className='mt-4 btn-red-outline' onClick={editContext} textValue='Edit Context' />

            <BaseOverlay show={showOverlay} className='overflow-auto h-[100dvh] rounded-none'>
                <div className='min-h-96 max-w-3xl w-full mx-auto px-8'>
                    <div className='flex justify-end py-4'>
                        <div className='text-theme1-primary font-bold' onClick={closeOverlay}>
                            Close
                        </div>
                    </div>
                    <div className='text-center text-theme1-title2 font-bold text-[22px] mb-3'>Edit Context</div>

                    <div className='mb-4'>
                        <textarea
                            className='w-full text-theme1-text1 p-4 border border-theme1-border1 rounded-lg h-[350px] focus:outline-none focus:ring-2 focus:ring-theme1-primary'
                            value={contextState}
                            onChange={handleContextChange}
                            placeholder='Edit meeting context'
                        />
                    </div>

                    <BaseButton
                        className='mt-4 btn-red-outline'
                        onClick={saveContext}
                        textValue={isLoading ? 'Saving...' : 'Save changes'}
                        disabled={isLoading}
                    />
                </div>
            </BaseOverlay>
        </>
    );
};

export default MeetingContextEdit;
